import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import S from './UspCard.styles';
const UspCard = (props) => {
    const imageSrc = props.image ? getSrcs(props.image, 176, 88, 2, 1 / 1) : null;
    const showCenterAlign = props.smallIcon && props.number === undefined
        ? 'center'
        : props.number
            ? 'left'
            : props.alignment ?? 'left';
    return (React.createElement(S.Container, { "data-alignment": showCenterAlign, "data-is-numbered": !!props.number, "data-small-icon": props.smallIcon },
        React.createElement(S.Grid, null,
            !props.number && imageSrc?.src && (React.createElement(S.ImageContainer, null, props.image && (React.createElement(S.Image, { src: imageSrc.src, srcSet: imageSrc.srcSet, sizes: `${until(Device.Tablet)} 88px, 176px`, alt: props.image.altText, loading: "lazy" })))),
            props.number && React.createElement(S.Number, null, props.number),
            React.createElement(S.ContentArea, null,
                React.createElement(S.Heading, { as: props.headingType }, props.title),
                props.description && (React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.description } })),
                props.cta && (React.createElement(S.CtaArea, null,
                    React.createElement(LinkButton, { href: props.cta.url, buttonType: props.cta.buttonType ?? 'secondary', icon: props.cta.icon, iconOnly: false }, props.cta.text)))))));
};
export default UspCard;
